import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { I18nModule, UrlModule } from '@spartacus/core'
import { IconModule, MediaModule, SearchBoxComponentService } from '@spartacus/storefront'

import { EbSearchBoxComponent } from './eb-search-box.component'
import { EbHighlightPipe } from './ebHighlight.pipe'
import { EbSearchBoxComponentService } from './services/eb-search-box-component.service'

@NgModule({
  exports: [EbSearchBoxComponent],
  imports: [
    CommonModule,
    RouterModule,
    MediaModule,
    IconModule,
    UrlModule,
    I18nModule,
    EbSearchBoxComponent,
    EbHighlightPipe
  ],
  providers: [
    {
      provide: SearchBoxComponentService,
      useClass: EbSearchBoxComponentService
    }
  ]
})
export class EbSearchBoxModule {}
